import PropTypes from "prop-types";

import { PAGE_MODULES } from "enums/pageModules";
import FeaturePanelItemPresenter from "presenters/FeaturePanelItemPresenter";
import Presenter from "utils/PropTypesPresenter";
import { getModuleMaxLimit } from "utils/pageModulesUtils";

export default new Presenter(
  {
    id: PropTypes.string,
    type: PropTypes.string,
    name: PropTypes.string,
    transitionInSeconds: PropTypes.number,
    cards: PropTypes.arrayOf(FeaturePanelItemPresenter.shape()),
  },
  {
    hitsPerPage(module, algoliaLimit) {
      return Math.min(getModuleMaxLimit(module), algoliaLimit);
    },
    algoliaCardFromCards(featurePanel) {
      return featurePanel?.cards?.find((card) => card?.data?.type === PAGE_MODULES.ALGOLIA_CARDS)?.data?.attributes;
    },
  },
);
